<script>
import CreateVenue from '@components/Global/modals/CreateVenue.vue';
import CreateVenueAndContact from '@components/Global/modals/CreateVenueAndContact.vue';

export default {
  name: 'CreateRenderer',
  functional: true,
  render(h, ctx) {
	function createComponent() {
	  const type = ctx.props.fieldType.toLowerCase()

	  if (type === 'venue') return CreateVenue
    if (type === 'venueandcontact') return CreateVenueAndContact
	  
	}
	return h(createComponent(), ctx.data, ctx.children)
  },
}
</script>
